import { Theme } from '@mui/material';
import { red } from '@mui/material/colors';
import { SystemStyleObject } from '@mui/system';

export type InputSize = 's' | 'm';
export type InputVariant = 'default' | 'iconLeading';

export const inputSizeSpecs: Record<InputSize, SystemStyleObject<Theme>> = {
  s: {
    padding: '8px 12px',
  },
  m: {
    padding: '10px 14px',
  },
};

export const inputFilledStyles = (theme: Theme, error?: boolean) => {
  const borderColor = error ? red[200] : theme.palette.grey[300];
  return {
    borderRadius: theme.spacing(1), // Apply border radius to the root
    alignItems: 'center',
    gap: theme.spacing(1),
    alignSelf: 'stretch',
    '& input': {
      p: 0,
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit', // Prevent border color change on hover
    },
    backgroundColor: theme.palette.common.white,
    boxShadow: `0 1px 2px 0 ${theme.palette.effects.shadowInner}`,
    color: theme.palette.grey[900],
    '&:hover': {
      borderColor,
    },
    '& fieldset': {
      borderRadius: theme.spacing(1), // Apply border radius to the fieldset
      border: `1px solid ${borderColor}`,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: error ? red[500] : theme.palette.brand.primary,
      borderWidth: '2px',
      color: theme.palette.grey[900],
    },
    'input::placeholder': {
      color: theme.palette.grey[600], // Set placeholder color to red
    },
  };
};

export const inputDisabledStyles = (theme: Theme, error?: boolean) => {
  const borderColor = error ? red[200] : theme.palette.grey[300];
  return {
    backgroundColor: theme.palette.grey[50],
    boxShadow: `0 1px 2px 0 ${theme.palette.effects.shadowInner}`,
    color: theme.palette.grey[600],
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor,
      borderWidth: '1px',
    },
  };
};
